<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>'베스트셀러 1위’ 휩쓴 에듀윌 토익 교재, 수험생도 에듀윌에 눈떴다!</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_07.jpg"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌에서 출간한 ‘에듀윌 토익 베이직 READING RC 4주끝장’ 교재가 온라인서점 YES24 국어 외국어 사전 영어 토익/TOEIC
                                기출문제/모의고사 분야에서 2022년 4월 4주차 주간 베스트셀러 1위를 달성했다.
                                <br>
                                <br>
                                이에 앞서, ‘에듀윌 토익 실전 LC+RC’ 교재는 온라인서점 알라딘 외국어 토익 실전분야에서 3월 4~5주차, 4월 1~2주차 주간 베스트셀러 1위를
                                차지하면서 에듀윌 토익 교재가 국내 유명 온라인서점 베스트셀러 1위를 휩쓸었다.
                                <br>
                                <br>
                                이는 지난 3월 중순 에듀윌이 토익을 선보인지 불과 한 달여만에 달성한 쾌거다.
                                <br>
                                <br>
                                예스24 베스트셀러 1위를 차지한 ‘에듀윌 토익 베이직 리딩’ 교재는 단 4주만에 입문에서 실전까지 단 한 권으로 끝내는 토익 입문서로 대표 기출 문법 유형,
                                빈출 어휘, 빠른 독해 전략, 최신 경향을 꿰뚫는 실전 문제까지 모든 내용을 한 권에 담은 것이 특징이다.
                                <br>
                                <br>
                                특히, 토익 입문자가 딱 4주 만에 700점을 받을 수 있게 하는 데 집중했다. 토익에서 자주 나오지 않는 복잡한 문법 이론과 중요하지 않은 유형 설명을
                                과감하게 쳐내고, 세 가지 필수 영역(문법, 어휘, 독해)에서 꼭 필요한 기본 개념을 확실하게 다질 수 있도록 구성했으며, 다양한 실전 문제와의 접목을 통해
                                최대한 빠르게 중급 이상의 점수를 얻을 수 있는데에 집중했다.
                                <br>
                                <br>
                                또한, 알라딘 베스트셀러 1위를 차지한 ‘에듀윌 토익 실전 LC+RC’ 교재는 토익 빅데이터 분석을 기반으로 최신 기출과 빈출 유형을 완벽히 조합해 단 5회의
                                모의고사로 실전에 대비할 수 있는 교재로 실제 토익 시험 그대로 리스닝과 리딩을 한번에 풀 수 있도록 마련했다. 이를 통해 자신의 약점을 정확하게 진단하고
                                보완하는 동시에 단기간에 실전 감각을 배양할 수 있도록 구성한 것이 특징이다.
                                <br>
                                <br>
                                에듀윌 토익 관계자는 “에듀윌 토익을 런칭한 지 불과 한 달여 만에 여러 온라인서점에서 베스트셀러 1위라는 성과를 달성하게 되어 기쁘다. 필요한 것만 학습해
                                수험생의 시간을 아껴주는 에듀윌 토익이 많은 토익커들에게 인정받고 있다는 반증이라고 생각한다”라며 “베스트셀러 1위라는 의미 있는 성과 달성에 힘입어,
                                앞으로도 최소한의 공부로 최대 점수 상승 효과를 낼 수 있는 콘텐츠 제공을 위해 노력하겠다”고 전했다.
                                <br>
                                <br>
                                온라인서점 베스트셀러 1위를 휩쓴 ‘에듀윌 토익’ 교재는 에듀윌 도서몰을 비롯해 예스24, 교보문고, 인터파크 도서, 알라딘 등 국내 주요 온·오프라인
                                서점에서 만나볼 수 있다.


                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news6" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 대한민국 일자리 으뜸기업에 세 번째 선정</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news8" data-value="315283">
                                        <strong>다음</strong>
                                        <span>에듀윌, 사이버보안 교육 과정 신규 런칭…’보안전문가’ 양성</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
